<h2
  mat-dialog-title
  style="background-color: #003366; color: white; padding: 10px"
>
  Editar feriado
</h2>
<mat-dialog-content>
  <div class="css-Campo_Default campo_default">
    <p class="css-Etiqueta etiqueta">Fecha</p>
    <div class="css-Campo_mensaje campo_mensaje">
      <mat-form-field appearance="outline" class="campo-fecha-custom">
        <input
          matInput
          [matDatepicker]="picker"
          placeholder="Elegir fecha"
          [(ngModel)]="selectedDate"
          (ngModelChange)="validateForm()"
        />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>

      <div
        class="css-mensaje_error mensaje_error error-off"
        *ngIf="mensaje_error_fecha.length > 0"
      >
        <div class="css-Icono_Error_Forms-1 icono_error_forms">
          <img
            src="assets/images/basecomponents-images/campo-default.svg"
            width="9px"
            height="9px"
            class="css-close close"
          />
        </div>
        <p class="css-Texto-1 texto">{{ mensaje_error_fecha }}</p>
      </div>
    </div>
  </div>

  <app-campo-default-admin
    descripcion_etiqueta="Descripción"
    placeholder_input=""
    [(ngModel)]="nombre"
    [mensaje_error]="mensaje_error_descripcion"
  >
  </app-campo-default-admin>
</mat-dialog-content>

<mat-dialog-actions style="justify-content: center; padding-bottom: 20px">
  <app-boton-primario
    boton_texto="Modificar"
    (boton_funcion)="modificar()"
  ></app-boton-primario>
  <div style="margin-left: 10px">
    <app-boton-primario
      boton_texto="Cancelar"
      (boton_funcion)="cancelar()"
      clase="red"
    ></app-boton-primario>
  </div>
</mat-dialog-actions>
